import { Box } from "@mui/material";
import EmployeeDetails from "../../components/Employee/EmployeeDetails";
import EmployeeTask from "../../components/Employee/EmployeeCreateTask";
import EmployeeShift from "../../components/Employee/EmployeeShift";
import EmployeeAttendance from "../../components/Employee/Attendance/EmployeeAttendance";

const Employee = ({ emp }) => {
  const type = emp;

  return (
    <>
      {
        type === "emptask" ? <EmployeeTask /> : type === "empshift" ? <EmployeeShift /> : type==="attendance"?<EmployeeAttendance/>:<EmployeeDetails />
      }


    </>
  );
};

export default Employee;
